import { IOrganization } from '../SuiteHeader.types';
// Prefix to identify MSA user from altsecId
export const MsaPrefix = '1:live.com:';
// Prefix to identify Social Idp user from altsecId
export const SIdpPrefix = '6:';

export interface IResourceTenant {
  readonly tenantId: string;
}

export interface IQueryOptions {
  readonly cacheTime?: number;
  readonly staleTime?: number;
}

export interface IQueryResponse {
  readonly data?: IOrganization[];
  readonly isLoading: boolean;
  readonly error: unknown;
}

export interface IResourceResponse {
  readonly value: IResourceTenant[];
}

export interface ITenantInfoPayload {
  readonly tenantId: string;
  readonly displayName: string;
  readonly federationBrandName: string;
  readonly defaultDomainName: string;
}

export enum SecurityIdentifierType {
  /**
   * LiveID User
   */
  LiveID = '1',
  Device = '2',
  CertificateSubjectNameAndIssuerIdentifier = '3',
  CertificateThumbprintIdentifier = '4',
  OrgID = '5',
  CustomAltSecId = '6',
  CrossCloudGuestUser = '8'
}
